import { render, staticRenderFns } from "./InsurerPlans.vue?vue&type=template&id=7d722fb2&"
import script from "./InsurerPlans.vue?vue&type=script&lang=ts&"
export * from "./InsurerPlans.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports